import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Blog } from './pages/Blog/Blog';
import { BlogPostPage } from './pages/BlogPost/BlogPost';
import { Contact } from './pages/Contact/Contact';
import { ExtraLinks } from './pages/ExtraLinks/ExtraLinks';
import { Home } from './pages/Home/Home';
import { NotFound } from './pages/NotFound/NotFound';
import { Portfolio } from './pages/Portfolio/Portfolio';
import { PrivacyPolicy } from './pages/PrivacyPolicy/PrivacyPolicy';
import { Projects } from './pages/Projects/Projects';
import { Store } from './pages/Store/Store';
import { TiktokLinks } from './pages/TiktokLinks/TiktokLinks';

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/links" element={<TiktokLinks />} />
      <Route path="/extra-links" element={<ExtraLinks />} />
      <Route path="/store" element={<Store />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
